module.exports = __webpack_public_path__ + "static/img/banner21.7fe37d8c.png";